export default "__VITE_ASSET__3u9Bsvms__"